<template>
  <div class="about-contactUs">
    <div class="about-contactUs-title">联系我们</div>
    <div class="about-contactUs-content">
      <div class="about-contactUs-content-tabs">
        <div
          class="about-contactUs-content-tabItem"
          :class="{
            'about-contactUs-content-tabItem-check': checkIndex == index
          }"
          v-for="(item, index) in list"
          :key="`about-contactUs-content-tabItem${index + 1}`"
          @click="checkIndex = index"
        >
          {{ item.area }}
        </div>
      </div>
      <div class="about-contactUs-content-info">
        <div
          v-if="list[checkIndex].address != ''"
          class="about-contactUs-content-info-item"
        >
          <div class="catgory">地址：</div>
          <div class="text">{{ list[checkIndex].address }}</div>
        </div>
        <div
          v-if="list[checkIndex].zipCode != ''"
          class="about-contactUs-content-info-item"
        >
          <div class="catgory">邮编：</div>
          <div class="text">{{ list[checkIndex].zipCode }}</div>
        </div>
        <div
          v-if="list[checkIndex].tel != ''"
          class="about-contactUs-content-info-item"
        >
          <div class="catgory">电话：</div>
          <div class="text">{{ list[checkIndex].tel }}</div>
        </div>
        <div
          v-if="list[checkIndex].telautogram != ''"
          class="about-contactUs-content-info-item"
        >
          <div class="catgory">传真：</div>
          <div class="text">{{ list[checkIndex].telautogram }}</div>
        </div>
        <div
          v-if="list[checkIndex].mail != ''"
          class="about-contactUs-content-info-item"
        >
          <div class="catgory">邮箱：</div>
          <div class="text">{{ list[checkIndex].mail }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          area: "上海",
          address: "上海市浦东新区中科路1750号模力社区T1幢22、23楼",
          zipCode: "",
          tel: "",
          telautogram: "",
          mail: "marketing@unidt.com"
        },
        {
          area: "杭州",
          address: "浙江省杭州市余杭区浙大校友经济产业园二期C5幢1401",
          zipCode: "",
          tel: "",
          telautogram: "",
          mail: "marketing@unidt.com"
        },
        {
          area: "西安",
          address: "陕西省西安市高新区锦业路绿地中心 B 座 1805",
          zipCode: "",
          tel: "",
          telautogram: "",
          mail: "marketing@unidt.com"
        },
        {
          area: "合肥",
          address:
            "安徽省合肥市瑶海区城东街道幸福路与桃花潭路交口中国网谷物联网科技产业园1号楼7层",
          zipCode: "",
          tel: "",
          telautogram: "",
          mail: "marketing@unidt.com"
        },
        {
          area: "成都",
          address: "成都市高新区交子大道33号中国华商金融中心T1栋16楼1601号",
          zipCode: "",
          tel: "",
          telautogram: "",
          mail: "marketing@unidt.com"
        },
        {
          area: "株洲",
          address: "湖南省株洲市天元区马家河街道仙月环路900号动力谷大厦15楼",
          zipCode: "",
          tel: "",
          telautogram: "",
          mail: "marketing@unidt.com"
        },
      ],
      checkIndex: 0
    };
  }
};
</script>
<style lang="less" scoped>
.about-contactUs {
  padding: 44px 64px 96px;
  background: #f8f9fb;
  .about-contactUs-title {
    font-size: 40px;
    color: #08204d;
    line-height: 56px;
    text-align: center;
  }
  .about-contactUs-content {
    width: 100%;
    margin-top: 32px;
    border: 2px solid #e6e7ed;
    display: flex;
    .about-contactUs-content-tabs {
      width: 114px;
      border-right: 2px solid #e6e7ed;
      text-align: center;
      flex: 0;
      .about-contactUs-content-tabItem {
        width: 114px;
        font-size: 28px;
        color: #08204d;
        line-height: 40px;
        margin: 16px 0;
      }
      .about-contactUs-content-tabItem-check {
        border-right: 6px solid blue;
      }
    }
    .about-contactUs-content-info {
      padding: 18px 16px 18px 32px;
      flex: 1;
      .about-contactUs-content-info-item {
        font-size: 26px;
        color: #08204d;
        line-height: 48px;
        margin: 10px 0;
        display: flex;
        justify-content: flex-start;
        .catgory {
          width: 90px;
        }
        .text {
          width: calc(100% - 90px);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about/contactUs.vue